// eslint-disable-next-line @typescript-eslint/no-restricted-types -- Authentication callbacks use null as their successful legacy sentinel.
type NullValue = null;

export type AuthInfo = {
  sessionId: string;
  traderId: string;
  upn: string;
};

export type AuthenticationType = {
  logout: () => Promise<void>;
  publishAuthorization: (data: AuthInfo) => Promise<void>;
  getCurrentCredentials: (cb?: (error: Error | NullValue | undefined, credentials?: AuthInfo | NullValue) => unknown) => Promise<AuthInfo | undefined>;
};
